import {PRODUCTION} from '../environments';

const getCanonicalUrl = (route: string): string => {
  if (process.env.STAGE === PRODUCTION || process.env.STAGE === 'test') {
    return `//www.fundingoptions.com${route}`;
  }

  return route;
};

export default getCanonicalUrl;
